import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./utils";
import type { SectionDraftGetResponse } from "../../../../src/api/src/documents/drafts/sections";

// eslint-disable-next-line
const sectionDraftTagType = "sectionDrafts" as const;

export const sectionDraftsApi = createApi({
  reducerPath: "sectionDraftsApi",
  baseQuery,
  tagTypes: [sectionDraftTagType],
  endpoints: (builder) => ({
    getSectionDrafts: builder.query<SectionDraftGetResponse, { docId: string }>(
      {
        query: ({ docId }) => `documents/${docId}/drafts/sections`,
        providesTags: (result) => [
          ...(result?.map((d) => ({
            type: sectionDraftTagType,
            id: d.id,
          })) ?? []),
          { type: sectionDraftTagType, id: "LIST" },
        ],
      },
    ),
  }),
});

export const { useGetSectionDraftsQuery } = sectionDraftsApi;
